export default Object.freeze({
  StripeAutomatic: 1,
  DistributorCredit: 2,
  ManualInvoice: 3,
});
